export const formatTime = (dateString: string, use24h: boolean = false): string => {
  const date = new Date(dateString);
  
  if (use24h) {
    return date.toLocaleTimeString('en-US', {
      hour: '2-digit',
      minute: '2-digit',
      hour12: false
    });
  } else {
    return date.toLocaleTimeString('en-US', {
      hour: 'numeric',
      minute: '2-digit',
      hour12: true
    });
  }
};

export const formatDateTime = (dateString: string, use24h: boolean = false): string => {
  const date = new Date(dateString);
  const dateStr = date.toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric'
  });
  const timeStr = formatTime(dateString, use24h);
  
  return `${dateStr} ${timeStr}`;
};

export const formatTimeInput = (dateString: string, use24h: boolean = false): string => {
  const date = new Date(dateString);
  
  if (use24h) {
    return date.toLocaleTimeString('en-US', {
      hour: '2-digit',
      minute: '2-digit',
      hour12: false
    });
  } else {
    return date.toLocaleTimeString('en-US', {
      hour: '2-digit',
      minute: '2-digit',
      hour12: true
    });
  }
};

export const parseTimeInput = (timeStr: string, use24h: boolean = false): Date => {
  const today = new Date();
  const [timePart, ampmPart] = timeStr.split(' ');
  const [hours, minutes] = timePart.split(':').map(Number);

  let hour24 = hours;

  if (!use24h && ampmPart) {
    if (ampmPart.toLowerCase() === 'pm' && hours !== 12) {
      hour24 = hours + 12;
    } else if (ampmPart.toLowerCase() === 'am' && hours === 12) {
      hour24 = 0;
    }
  }

  const result = new Date(today);
  result.setHours(hour24, minutes, 0, 0);
  return result;
};

export const formatDateTimeRelative = (dateString: string, use24h: boolean = false): string => {
  const date = new Date(dateString);
  const now = new Date();
  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  const dateOnly = new Date(date.getFullYear(), date.getMonth(), date.getDate());

  const timeStr = formatTime(dateString, use24h);

  // Check if it's today
  if (dateOnly.getTime() === today.getTime()) {
    return `today at ${timeStr}`;
  }

  // Check if it's yesterday
  const yesterday = new Date(today);
  yesterday.setDate(yesterday.getDate() - 1);
  if (dateOnly.getTime() === yesterday.getTime()) {
    return `yesterday at ${timeStr}`;
  }

  // Check if it's tomorrow
  const tomorrow = new Date(today);
  tomorrow.setDate(tomorrow.getDate() + 1);
  if (dateOnly.getTime() === tomorrow.getTime()) {
    return `tomorrow at ${timeStr}`;
  }

  // Default: show date with time
  return formatDateTime(dateString, use24h);
};